function normalizeBase(base) {
  if (!base || base === "./") return "/";
  const withSlashes = `/${String(base).replace(/^\/+|\/+$/g, "")}/`;
  return withSlashes === "//" ? "/" : withSlashes;
}

export const appBase = normalizeBase(import.meta.env.BASE_URL);

export function withBase(path = "/") {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (appBase === "/") return normalizedPath;
  return `${appBase.replace(/\/$/, "")}${normalizedPath}`;
}

export function withoutBase(pathname = "/") {
  const baseWithoutSlash = appBase.replace(/\/$/, "");
  if (
    baseWithoutSlash &&
    baseWithoutSlash !== "/" &&
    (pathname === baseWithoutSlash || pathname.startsWith(`${baseWithoutSlash}/`))
  ) {
    return pathname.slice(baseWithoutSlash.length) || "/";
  }
  return pathname;
}

export function assetUrl(path) {
  return withBase(path);
}
